"use client";

import React, { useEffect, useState } from "react";
import { Sparkles, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheGrandEntrance() {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return <section id="the-grand-entrance" className="relative min-h-screen w-full bg-transparent text-white/90 overflow-hidden">
      {}
      

      {}
      <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden">
        {isMounted && <>
            {}
            {Array.from({
          length: 100
        }).map((_, i) => <div key={`dot-${i}`} data-index={i} className="absolute w-1 h-1 bg-white rounded-full opacity-40 animate-float" style={{
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 10}s`,
          animationDuration: `${7 + Math.random() * 8}s`
        }} />)}
            {}
            {Array.from({
          length: 60
        }).map((_, i) => <div key={`glow-${i}`} data-index={i} className="absolute w-4 h-4 bg-secondary/20 rounded-full blur-xl animate-float-slow" style={{
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 12}s`,
          animationDuration: `${10 + Math.random() * 10}s`
        }} />)}
            {}
            {Array.from({
          length: 30
        }).map((_, i) => <div key={`star-${i}`} data-index={i} className="absolute animate-twinkle" style={{
          top: `${Math.random() * 90}%`,
          left: `${Math.random() * 95}%`,
          animationDelay: `${Math.random() * 5}s`
        }}>
                <Star className="star w-3 h-3 text-secondary/60 fill-secondary/40" />
              </div>)}
            {}
            {Array.from({
          length: 20
        }).map((_, i) => <div key={`sparkle-${i}`} data-index={i} className="absolute animate-sparkle" style={{
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 8}s`
        }}>
                <Sparkles className="w-4 h-4 text-white/50" />
              </div>)}
          </>}
      </div>

      {}
      <div className="relative z-30 flex flex-col items-center justify-center min-h-screen px-4 text-center pt-40 md:pt-24">
        
        {}
        <img src="https://loved-mayfly.10web.cloud/wp-content/uploads/2026/03/Abracadabra-Events-Logo-Rectangular.png" alt="Abracadabra Events Logo" className="h-64 md:h-96 w-auto mb-0 animate-in fade-in slide-in-from-top-4 duration-1000 object-contain" />
        <h2 className="font-serif text-2xl md:text-3xl font-bold tracking-[0.3em] !text-secondary mb-2 animate-in fade-in slide-in-from-top-4 duration-1000">
          Experience the Wonder
        </h2>

        {}
        <div className="mb-6 mt-4 relative">
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight drop-shadow-[0_0_15px_rgba(255,255,255,0.3)] animate-in fade-in zoom-in duration-1000 pb-4">
            Create the Magic
          </h1>
          <h1 className="absolute inset-0 font-serif text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight text-primary/10 blur-xl select-none pointer-events-none" aria-hidden="true">
            Create the Magic
          </h1>
        </div>

        {}
        <h3 className="font-serif text-3xl md:text-4xl font-bold tracking-[0.1em] !text-secondary mb-12 max-w-4xl mx-auto drop-shadow-md animate-in slide-in-from-bottom-8 fade-in duration-1000 delay-300">Creative Stress-Free Events for Every Occasion</h3>

        {}
        <div className="animate-in slide-in-from-bottom-12 fade-in duration-1000 delay-500">
          <Button asChild size="lg" className="rounded-full px-10 py-8 text-xl md:text-2xl font-serif font-bold bg-primary text-white hover:bg-primary/90 hover:scale-105 transition-all duration-300 shadow-[0_0_25px_rgba(212,175,55,0.3)] border-2 border-secondary/50 animate-[pulse_4s_ease-in-out_infinite]">
            <Link to="#summon-the-magic">
              <Sparkles className="w-6 h-6 mr-2 animate-spin-slow text-white" />
              Start the Magic
            </Link>
          </Button>
        </div>

        {}
        <div className="absolute bottom-12 left-12 animate-bounce delay-700 opacity-60 hidden md:block">
          <Star className="star text-white w-8 h-8 fill-white/20" />
        </div>
        <div className="absolute top-1/4 left-[8%] animate-pulse delay-1000 opacity-40 hidden md:block">
          <Star className="star text-white w-5 h-5 fill-white/30" />
        </div>
      </div>

      <style>{`
        @keyframes float {
          0% {
            transform: translateY(0) translateX(0);
            opacity: 0;
          }
          15% {
            opacity: 0.6;
          }
          85% {
            opacity: 0.3;
          }
          100% {
            transform: translateY(-25vh) translateX(30px);
            opacity: 0;
          }
        }
        
        @keyframes float-slow {
          0% {
            transform: translateY(0) translateX(0) scale(1);
            opacity: 0;
          }
          20% {
            opacity: 0.4;
          }
          80% {
            opacity: 0.2;
          }
          100% {
            transform: translateY(-90vh) translateX(40px) scale(1.4);
            opacity: 0;
          }
        }

        @keyframes twinkle {
          0%, 100% { opacity: 0.3; transform: scale(0.9); }
          50% { opacity: 1; transform: scale(1.1); }
        }

        @keyframes sparkle {
          0%, 100% { opacity: 0; transform: scale(0.5) rotate(0deg); }
          50% { opacity: 0.8; transform: scale(1.2) rotate(180deg); }
        }
        
        .animate-float {
          animation: float linear infinite;
        }
        
        .animate-float-slow {
          animation: float-slow linear infinite;
        }

        .animate-twinkle {
          animation: twinkle 4s ease-in-out infinite;
        }

        .animate-sparkle {
          animation: sparkle 5s ease-in-out infinite;
        }

        .animate-spin-slow {
          animation: spin 6s linear infinite;
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </section>;
}